module.exports = __webpack_public_path__ + "stockLibrary/icon-delete-d044e9d5eff23e7bc06124e0b6d4be40.svg";